import { http } from '@/api/client'

export interface VersionCheckResult {
  has_update: boolean
  latest_version: string
  version_code: number
  download_url: string
  force_update: boolean
  description: string
}

export async function checkVersion(
  platform: 'android' | 'exe' | 'mac',
  currentVersion: string,
): Promise<VersionCheckResult> {
  const res = await http.get<VersionCheckResult>('/version/check', {
    params: { platform, current_version: currentVersion },
  })
  return res.data
}
